<script setup lang="ts">
import { ToggleLeft, ToggleRight } from "lucide-vue-next";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const isEditor = computed(() => route.name === "Editor");
const isRecord = computed(() => route.name === "Records");
const isTelemetry = computed(() => route.name === "Track");
const deviceId = computed(() => route.params.deviceId);

// Testo dinamico
const targetName = computed(() =>
  isEditor.value || isRecord.value || isTelemetry.value ? "Data" : "Editor"
);
const text = computed(() =>
  isEditor.value || isRecord.value || isTelemetry.value ? "Vai ai" : "Vai all'"
);
const ctaText = computed(() => `${text.value} ${targetName.value}`);

function toggle() {
  router.push({ name: targetName.value, params: { deviceId: deviceId.value } });
}
</script>

<template>
  <!-- pulsante accessibile con etichetta -->
  <button
    class="icon-toggle"
    :class="{ 'on-telemetry': isTelemetry }"
    :aria-pressed="isEditor ? 'true' : 'false'"
    :aria-label="ctaText"
    :title="ctaText"
    @click="toggle"
  >
    <ToggleLeft v-if="isEditor" />
    <ToggleRight v-else />

    <!-- Etichetta contestuale (mostrata su hover/focus o sempre su desktop ampio) -->
    <span class="toggle-label">{{ ctaText }}</span>
  </button>
</template>

<style scoped>
.icon-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  cursor: pointer;
  background: transparent;
  border: 1px solid transparent;
  transition: all 0.15s ease;
  white-space: nowrap;
  overflow: visible;
}

/* Background specifico per Telemetria (come da immagine) */
.icon-toggle.on-telemetry {
  background: #14181d;
  border-color: #2a2f34;
}

/* .icon-toggle.on-telemetry .toggle-label,
.icon-toggle.on-telemetry :deep(svg) {
  color: #fff !important;
} */

/* opzionale: leggero hover */
.icon-toggle:hover {
  background: #14181d;
  border-color: #2a2f34;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
  transform: translateY(-1px);
}

.icon-toggle:hover .toggle-label,
.icon-toggle:hover :deep(svg) {
  color: #00b3b3 !important;
}

.icon-toggle:focus-visible {
  outline: 2px solid #008f8f;
  outline-offset: 2px;
}
.icon-toggle:active {
  transform: scale(0.96);
}

/* L’icona Lucide usa stroke=currentColor: fissiamo un color sicuro */
.icon-toggle :deep(svg) {
  width: 24px;
  height: 24px;
  color: #008f8f; /* Coerente con la label */
  flex: 0 0 auto;
  stroke-width: 2.2;
  transition: color 0.15s;
}

/* Label SEMPRE visibile */
.toggle-label {
  display: inline-block;
  margin-left: 2px;
  color: #008f8f;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}
</style>
